"use client";

import { useEffect } from "react";
import { scrollBehaviorTo } from "@/utils";

export const useScrollToHeader = (enabled = true) => {
  useEffect(() => {
    if (!enabled || typeof window === "undefined") return;

    const header = document.querySelector(".header");
    if (!header) {
      scrollBehaviorTo(0);
      return;
    }

    scrollBehaviorTo(header.getBoundingClientRect().top + window.scrollY);
  }, [enabled]);
};
